import { PRICING_TYPE } from '../SkillGeoDifferential/SkillGeoDifferentialReducer';
import GG_DEFAULTS from '../../lib/genericGridDefaults';
import { getColumnIndex } from 'ps-components/AdvancedTable/GenericGrid/GenericGridHelper';

const NOT_ALPHA_NUMERIC_REGEX = /[^a-zA-Z0-9]+/g;

export function getUniqueMatchKey(match, pricingType) {
  if (pricingType === PRICING_TYPE.SLOTTED) {
    return `${getCleansedString(match.slotJobCode)}--${getCleansedString(match.slotJobCodeKey)}`;
  }
  return `${getCleansedString(match.surveyJobCode)}--${getCleansedString(match.surveySourceCode)}--${getCleansedString(
    match.surveyDatacut
  )}`;
}

function getCleansedString(string) {
  return string.replace(NOT_ALPHA_NUMERIC_REGEX, '');
}

export function isAdHocJobId(jobId) {
  return jobId !== undefined && jobId <= 100;
}

export function truncateDecimals(number, decimalPlaces) {
  const reg = new RegExp('(\\d+\\.\\d{' + decimalPlaces + '})(\\d)');
  const match = Number(number)
    .toString()
    .match(reg);
  return match ? parseFloat(match[1]) : number.valueOf();
}

export function getSelectedCutIds(jobPricingGrid) {
  const cutIdIndex = getColumnIndex(jobPricingGrid, 'cut_id_default');
  if (cutIdIndex !== -1) {
    return jobPricingGrid.data.map(survey => survey[cutIdIndex]);
  }
  return [];
}

export function getSelectedSurveys(jobPricingGrid) {
  const surveyCodeIndex = getColumnIndex(jobPricingGrid, 'survey_code_default');
  const jobCodeIndex = getColumnIndex(jobPricingGrid, 'job_code_default');
  const cutIdIndex = getColumnIndex(jobPricingGrid, 'cut_id_default');
  if (surveyCodeIndex !== -1 && jobCodeIndex !== -1 && cutIdIndex !== -1) {
    return jobPricingGrid.data.map(survey => {
      return { surveyCode: survey[surveyCodeIndex], surveyJobCode: survey[jobCodeIndex], cutId: survey[cutIdIndex] };
    });
  }
  return [];
}

export function getCurrentAgingCode(jobPricingGrid) {
  const agingCodeIndex = getColumnIndex(jobPricingGrid, GG_DEFAULTS.AGING_CODE);
  if (agingCodeIndex !== -1 && jobPricingGrid.data?.length > 0) {
    return jobPricingGrid.data[0][agingCodeIndex];
  }
  return undefined;
}
